import { render } from "./CusSelect.vue?vue&type=template&id=4619ff61&scoped=true"
import script from "./CusSelect.vue?vue&type=script&lang=js"
export * from "./CusSelect.vue?vue&type=script&lang=js"

import "./CusSelect.vue?vue&type=style&index=0&id=4619ff61&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/yang/wms-image/wms-image-pc/Commodity_Wms_Pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4619ff61"]])

export default __exports__